/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { Link } from 'react-router';
import styles from './styles.scss';


const defaultProps = {
  className: 'aisz-form-control',
  value: '',
  children: null,
  onChange: () => {},
  placeholder: null,
  options: [],
};

const propTypes = {
  className: React.PropTypes.string,
  value: React.PropTypes.any,
  children: React.PropTypes.any,
  onChange: React.PropTypes.func,
  placeholder: React.PropTypes.string,
  options: React.PropTypes.array,
};

class SearchSelMultiple extends React.Component {

  constructor(props) {
    super(props);
    let options = props.options;
    if (!options) {
      options = React.Children.map(
        props.children,
        c => ({
          value: c.props.value,
          label: String(c.props.children),
        }));
    }
    this.selectValue = [props.value];
    this.options = options.map(opt => ({
      ...opt,
      active: _.includes(this.selectValue, props.value),
    }));

    this.state = {
      value: props.value,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSelectOption = this.handleSelectOption.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { value, options } = nextProps;
    if (value !== this.props.value) {
      this.setState({ value });
    }
    if (options !== this.props.options) {
      this.options = options;
    }
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  handleInputChange(e) {
    const inputLabel = e.target.value;
    let options;
    if (inputLabel === '') {
      // options = this.options;
      options = this.options.map(o => ({
        ...o,
        active: _.includes(this.selectValue, o.value),
      }));
    } else {
      options = this.options.filter(
        opt => String(opt.label).toUpperCase().indexOf(inputLabel.toUpperCase()) >= 0);
      options = options.map(o => ({
        ...o,
        active: _.includes(this.selectValue, o.value),
      }));
    }

    this.setState({
      inputLabel,
      options,
      open: true,
    });
  }

  handleSelectOption(opt) {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    if (_.includes(this.selectValue, opt.value)) {
      this.selectValue = _.filter(this.selectValue, s => s !== opt.value);
    } else {
      this.selectValue = _.concat(this.selectValue, [opt.value]);
    }
    this.selectValue = _.filter(this.selectValue, s => !_.isNil(s) && s !== '');
    this.setState({
      value: this.selectValue[0],
      options: this.options.map(o => ({
        ...o,
        active: _.includes(this.selectValue, o.value),
      })),
      // open: false,
    });
    if (this.iptRef) {
      this.iptRef.focus();
    }

    const { onChange } = this.props;
    if (onChange) {
      onChange(this.selectValue);
    }
  }

  handleFocus() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    this.setState({
      options: this.options.map(opt => ({
        ...opt,
        active: _.includes(this.selectValue, opt.value),
      })),
      inputLabel: '',
      open: true,
    });
  }

  handleBlur() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(
      () => this.setState({ open: false }),
      300);
  }

  handleKeyDown(e) {
    if (e.key === 'Enter') {
      const { open, options = [] } = this.state;
      if (open && options[0]) {
        this.handleSelectOption(options[0]);
      }
    }
  }

  render() {
    const {
      children,
      className = 'aisz-form-control',
      placeholder,
      styles: s,   // eslint-disable-line
      value: v,    // eslint-disable-line
      options: o,  // eslint-disable-line
      ...rest
    } = this.props;
    const {
      value,
      options = [],
      open = false,
    } = this.state;
    let { inputLabel = '' } = this.state;

    if (!open) {
      const currOpt = this.options.find(opt => opt.value === value);
      if (currOpt) {
        inputLabel = currOpt.label;
      }
    }

    return (
      <div className={`${styles.select} ${open ? styles.open : ''} select`}>
        <select {...rest} value={value || ''}>
          { children }
        </select>
        <input
          className={className}
          value={inputLabel}
          onChange={this.handleInputChange}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          onKeyDown={this.handleKeyDown}
          placeholder={placeholder}
          ref={(r) => { this.iptRef = r; }}
        />
        <div className={styles.dropdown}>
          <ul>
            {options.map((opt, idx) => {
              let label = <span>{opt.label}</span>;
              if (opt.formatter) {
                label = opt.formatter(opt.label);
              }
              return (
                <li
                  className={`${opt.active ? styles.active : ''} ${idx === 0 ? styles.hover : ''}`}
                  key={opt.value}
                  style={{ ...opt.style }}
                >
                  <Link onClick={() => this.handleSelectOption(opt)}>
                    {label}
                    {opt.active && <i className="fa fa-check" />}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    );
  }
}

SearchSelMultiple.defaultProps = defaultProps;
SearchSelMultiple.propTypes = propTypes;

export default SearchSelMultiple;




// WEBPACK FOOTER //
// ./src/components/SearchSelMultiple/index.jsx